import styled from 'styled-components';
import { Image } from 'antd';

interface TitleContainerProps {
    $showMenu: boolean;
    $iconTitleGap?: number;
}

export const PageTitleContainer = styled('div')<TitleContainerProps>`
    display: flex;
    align-items: center;
    gap: ${(props) => props.$iconTitleGap ?? 8}px;
    margin-left: ${(props) => (props.$showMenu ? '38px' : '0px')};
`;

export const PageTitleIcon = styled(Image)`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    filter: brightness(0) invert(1);
`;

interface CustomProps {
    showMenu: boolean;
}

export const PageTitleText = styled('h1')`
    margin: 0;
    font-style: normal;
    font-weight: normal;
    font-family: 'Proxima N W15 Bold';
    font-size: 24px;
    line-height: 28px;
    color: #ffffff;
    max-width: 570px;
    word-break: break-word;
    &.invisible-title {
        opacity: 0;
    }
`;
